import "../../components/EventUserDashboard.css";
import AdminBackBar from "../../components/admin/AdminBackBar";
import Billede1 from "../../Images/Billede1.jpg";
import HeroSectionV2 from "../../components/HeroSectionV2";
import React, { useEffect, useState } from "react";
import {
    Paper,
    Title,
    Text,
    Stack,
    Grid,
    Group,
    Button,
    Select,
    TextInput,
    Checkbox,
    Badge,
    Divider,
} from "@mantine/core";

const API_URL = process.env.REACT_APP_API_URL ?? "";

type Event = {
    eventID: number;
    eventName: string;
};
type EventBar = {
    eventBarId: number;
    eventId: number;
    name: string;
    isActive: boolean;
};

type Invoice = {
    invoiceId: number;
    eventId: number;
    name: string;
    isActive: boolean;
};
export default function EventBars() {
    const [events, setEvents] = useState<Event[]>([]);
    const [eventId, setEventId] = useState<number | null>(null);
    const [editingBar, setEditingBar] = useState<EventBar | null>(null);
    const [editingInvoice, setEditingInvoice] = useState<Invoice | null>(null);
    const [bars, setBars] = useState<EventBar[]>([]);
    const [originalBars, setOriginalBars] = useState<EventBar[]>([]);
    const [loading, setLoading] = useState(false);
    const [newBar, setNewBar] = useState({
        name: "",
        isActive: true,
    });

    // ================= INVOICE STATE =================
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [originalInvoices, setOriginalInvoices] = useState<Invoice[]>([]);
        const [newInvoice, setNewInvoice] = useState({
        name: "",
        isActive: true,
    });
    // ---------------- LOAD EVENTS ----------------
    const loadEvents = async () => {
        try {
            const res = await fetch(`${API_URL}/api/events`);
            if (!res.ok) {
                throw new Error(`Kunne ikke hente events: ${res.status} ${res.statusText}`);
            }
            const data = await res.json();
            setEvents(Array.isArray(data) ? data : []);
        } catch {
            setEvents([]);
        }
    };

    // ---------------- LOAD BARS ----------------
    const loadBars = async (id: number) => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/EventBars/event/${id}`);
            if (!res.ok) {
                throw new Error(`Kunne ikke hente barer: ${res.status} ${res.statusText}`);
            }
            const data = await res.json();
            const safe = Array.isArray(data) ? data : [];
            setBars(safe);
            setOriginalBars(safe);
        }
        finally {
            setLoading(false);
        }
    };

    // ================= LOAD INVOICES =================
    const loadInvoices = async (id: number) => {
        try {
            const res =
                await fetch(`${API_URL}/api/invoices/event/${id}`);
            if (!res.ok) {
                throw new Error(`Kunne ikke hente fakturaer: ${res.status} ${res.statusText}`);
            }
            const data =
                await res.json();
            const safe =
                Array.isArray(data)
                    ? data
                    : [];
            setInvoices(safe);
            setOriginalInvoices(safe);
        } catch {
            setInvoices([]);
            setOriginalInvoices([]);
        }
    };
    useEffect(() => {
        loadEvents();
    }, []);
    useEffect(() => {
        if (eventId !== null) {
            loadBars(eventId);
            loadInvoices(eventId);
        }
        else {
            setBars([]);
            setOriginalBars([]);
            setInvoices([]);
            setOriginalInvoices([]);
        }
    }, [eventId]);

    // ---------------- CREATE BAR ----------------
    const createBar = async () => {
        if (!eventId)
            return;
        await fetch(`${API_URL}/api/EventBars`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    eventId,
                    name: newBar.name,
                    isActive: newBar.isActive,
                }),
            });
        setNewBar({
            name: "",
            isActive: true,
        });
        loadBars(eventId);
    };

    // ---------------- UPDATE BAR ----------------
    const updateBar = async (bar: EventBar) => {
        await fetch(`${API_URL}/api/EventBars/${bar.eventBarId}`,
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(bar),
            });

        if (eventId)
            loadBars(eventId);
    };

    const saveBarEdit = async () => {
        if (!editingBar)
            return;

        await updateBar(editingBar);

        setEditingBar(null);
    };






    // ---------------- DELETE BAR ----------------

    const deleteBar = async (id: number) => {


        await fetch(`${API_URL}/api/EventBars/${id}`,
            {

                method: "DELETE",

            });



        setBars((prev) =>
            prev.filter((b) => b.eventBarId !== id)
        );



        setOriginalBars((prev) =>
            prev.filter((b) => b.eventBarId !== id)
        );


    };









    // ================= INVOICE CRUD =================



    const createInvoice = async () => {

        if (!eventId)
            return;


        await fetch(`${API_URL}/api/invoices`,
            {
                method: "POST",

                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify({
                    ...newInvoice,
                    eventId
                }),
            }
        );


        setNewInvoice({
            name: "",
            isActive: true,
        });


        loadInvoices(eventId);

    };

    const updateInvoice = async (invoice: Invoice) => {

        await fetch(`${API_URL}/api/invoices/${invoice.invoiceId}`,
            {
                method: "PUT",

                headers: {
                    "Content-Type": "application/json",
                },

                body: JSON.stringify(invoice),

            });


        if (eventId) {
            loadInvoices(eventId);
        }

    };

    const saveInvoiceEdit = async () => {
        if (!editingInvoice)
            return;

        await updateInvoice(editingInvoice);

        setEditingInvoice(null);
    };

    const deleteInvoice = async (id: number) => {


        await fetch(`${API_URL}/api/invoices/${id}`,
            {

                method: "DELETE",

            });



        setInvoices((prev) =>

            prev.filter(i =>
                i.invoiceId !== id
            )

        );


    };


    return (
        <div>

            <HeroSectionV2
                titleEn="Manage Bars and invoices"
                titleDa="Administrer Bar og Faktura"
                descriptionEn="Here you can create and manage bars and invoices"
                descriptionDa="Her kan du oprette bar og faktura til Events"
                imageSrc={Billede1}
            />

            <AdminBackBar
                title="Drinks"
                crumbs={[
                    { label: "Admin", to: "/admin" },
                    { label: "Drinks" }
                ]}
            />


            <div className="content">


                <Title order={3} mb="md">
                    Select Event
                </Title>


                <Select
                    label="Event"
                    placeholder="Select event"
                    value={eventId?.toString() ?? null}
                    onChange={(value) =>
                        setEventId(value ? Number(value) : null)
                    }
                    data={events.map(event => ({
                        value: event.eventID.toString(),
                        label: event.eventName,
                    }))}
                    searchable
                    mb="xl"
                />



                {!eventId ? (

                    <Text mt="md">
                        Select an event to manage bars and invoices.
                    </Text>


                ) : (


                    <Grid gutter="xl">


                        {/* BARS */}

                        <Grid.Col
                            span={{
                                base: 12,
                                md: 6
                            }}
                        >


                            <Stack>


                                <Paper
                                    shadow="sm"
                                    p="lg"
                                    radius="md"
                                    withBorder
                                >

                                    <Stack>

                                        <Title order={4}>
                                            Create Bar
                                        </Title>


                                        <TextInput
                                            label="Bar Name"
                                            placeholder="Enter bar name"
                                            value={newBar.name}
                                            onChange={(e) =>
                                                setNewBar(prev => ({
                                                    ...prev,
                                                    name: e.target.value
                                                }))
                                            }
                                        />


                                        <Checkbox
                                            label="Active"
                                            checked={newBar.isActive}
                                            onChange={(e) =>
                                                setNewBar(prev => ({
                                                    ...prev,
                                                    isActive: e.currentTarget.checked
                                                }))
                                            }
                                        />


                                        <Button onClick={createBar}>
                                            Add Bar
                                        </Button>


                                    </Stack>

                                </Paper>



                                {editingBar && (

                                    <Paper
                                        shadow="sm"
                                        p="lg"
                                        radius="md"
                                        withBorder
                                    >

                                        <Stack>

                                            <Title order={4}>
                                                Edit Bar
                                            </Title>


                                            <TextInput
                                                label="Bar Name"
                                                value={editingBar.name}
                                                onChange={(e) =>
                                                    setEditingBar(prev =>
                                                        prev
                                                            ? {
                                                                ...prev,
                                                                name: e.target.value
                                                            }
                                                            : null
                                                    )
                                                }
                                            />


                                            <Checkbox
                                                label="Active"
                                                checked={editingBar.isActive}
                                                onChange={(e) =>
                                                    setEditingBar(prev =>
                                                        prev
                                                            ? {
                                                                ...prev,
                                                                isActive: e.currentTarget.checked
                                                            }
                                                            : null
                                                    )
                                                }
                                            />


                                            <Button onClick={saveBarEdit}>
                                                Save Changes
                                            </Button>

                                        </Stack>

                                    </Paper>

                                )}
                                <Title order={4}>
                                    Existing Bars
                                </Title>
                               <Stack>
                                    {bars.map(bar => (
                                        <Paper
                                            key={bar.eventBarId}
                                            shadow="xs"
                                            p="md"
                                            radius="md"
                                            withBorder
                                        >
                                            <Group justify="space-between">
                                                <Stack gap={5}>
                                                    <Text fw={600}>
                                                        {bar.name}
                                                    </Text>
                                                    <Badge
                                                        color={
                                                            bar.isActive
                                                                ? "green"
                                                                : "gray"
                                                        }
                                                    >
                                                        {
                                                            bar.isActive
                                                                ? "Active"
                                                                : "Inactive"
                                                        }
                                                    </Badge>
                                                </Stack>
                                                <Group>
                                                   <Button
                                                        variant="light"
                                                        onClick={() =>
                                                            setEditingBar(bar)
                                                        }
                                                    >
                                                        Edit
                                                    </Button>
                                                    <Button
                                                        color="red"
                                                        onClick={() =>
                                                            deleteBar(
                                                                bar.eventBarId
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>
                                                </Group>
                                            </Group>
                                        </Paper>
                                    ))}
                                </Stack>
                            </Stack>
                        </Grid.Col>
                        {/* INVOICES */}
                        <Grid.Col span={{base: 12, md: 6}}
                        >
                            <Stack>
                                <Paper shadow="sm" p="lg" radius="md" withBorder>
                                    <Stack>
                                        <Title order={4}>
                                            Create Invoice
                                        </Title>
                                        <TextInput
                                            label="Invoice Name"
                                            placeholder="Enter invoice name"
                                            value={newInvoice.name}
                                            onChange={(e) =>
                                                setNewInvoice(prev => ({
                                                    ...prev,
                                                    name: e.target.value
                                                }))
                                            }
                                        />
                                        <Checkbox
                                            label="Active"
                                            checked={newInvoice.isActive}
                                            onChange={(e) =>
                                                setNewInvoice(prev => ({
                                                    ...prev,
                                                    isActive: e.currentTarget.checked
                                                }))
                                            }
                                        />
                                        <Button onClick={createInvoice}>
                                            Add Invoice
                                        </Button>
                                    </Stack>
                                </Paper>
                                {editingInvoice && (
                                    <Paper
                                        shadow="sm"
                                        p="lg"
                                        radius="md"
                                        withBorder
                                    >
                                        <Stack>
                                            <Title order={4}>
                                                Edit Invoice
                                            </Title>
                                            <TextInput
                                                label="Invoice Name"
                                                value={editingInvoice.name}
                                                onChange={(e) =>
                                                    setEditingInvoice(prev =>
                                                        prev
                                                            ? {
                                                                ...prev,
                                                                name: e.target.value
                                                            }
                                                            : null
                                                    )
                                                }
                                            />
                                            <Checkbox
                                                label="Active"
                                                checked={editingInvoice.isActive}
                                                onChange={(e) =>
                                                    setEditingInvoice(prev =>
                                                        prev
                                                            ? {
                                                                ...prev,
                                                                isActive: e.currentTarget.checked
                                                            }
                                                            : null
                                                    )
                                                }
                                            />
                                            <Button onClick={saveInvoiceEdit}>
                                                Save Changes
                                            </Button>
                                        </Stack>
                                    </Paper>
                                )}
                                <Title order={4}>
                                    Existing Invoices
                                </Title>
                                <Stack>
                                    {invoices.map(invoice => (
                                        <Paper
                                            key={invoice.invoiceId}
                                            shadow="xs"
                                            p="md"
                                            radius="md"
                                            withBorder
                                        >
                                            <Group justify="space-between">
                                                <Stack gap={5}>
                                                    <Text fw={600}>
                                                        {invoice.name}
                                                    </Text>
                                                    <Badge color={
                                                            invoice.isActive
                                                                ? "green"
                                                                : "gray"
                                                        }
                                                    >
                                                        {
                                                            invoice.isActive
                                                                ? "Active"
                                                                : "Inactive"
                                                        }
                                                    </Badge>
                                                </Stack>
                                                <Group>
                                                    <Button
                                                        variant="light"
                                                        onClick={() =>
                                                            setEditingInvoice(invoice)
                                                        }
                                                    >
                                                        Edit
                                                    </Button>
                                                    <Button
                                                        color="red"
                                                        onClick={() =>
                                                            deleteInvoice(
                                                                invoice.invoiceId
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>
                                                </Group>
                                            </Group>
                                        </Paper>
                                    ))}
                                </Stack>
                            </Stack>
                        </Grid.Col>
                    </Grid>
                )}
            </div>
        </div>
    );
}